<template>
	<div class="Navigation">

		<md-button class="md-icon-button na-gallery" @click="toggleGallery">
			<span class="situationName">{{currentSituation ? currentSituation.getName() : "undefined"}}</span>	
			<ChevronDown v-if="!situationGalleryVisible"/>
			<ChevronUp v-else/>
		</md-button>

		<div class="na-navbar">
			
			<transition name="fade" mode="out-in">
				<div class="na-navbar-tooltip" :key="buttonName">{{buttonName}}</div>
			</transition>

			<div class="na-navbar-buttons">
				<md-button v-if="enableMap" class="md-icon-button" :class="{ 'active-Icon': mapVisible }" @click="toggleMap" :md-ripple="false" @mouseover="buttonName = 'Zur Übersicht'">
					<img src="@/assets/Map.svg" class="na-navbar-button-img" alt=""/>
				</md-button>														

				<md-button class="md-icon-button" :class="{ 'active-Icon': fullScreen }" @click="toggleFullScreen" :md-ripple="false" @mouseover="buttonName = 'Vollbildmodus'">
					<img src="@/assets/Fullscreen.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button v-if="enableSharing" class="md-icon-button" :class="{ 'active-Icon': sharingVisible }" @click="toggleSharing" :md-ripple="false" @mouseover="buttonName = 'Teilen'">
					<ShareIcon/>
				</md-button>

				<md-button  v-if="localUserIsModerator" class="md-icon-button" @click="toggleModeratorMenue" :md-ripple="false" @mouseover="buttonName = 'Moderatorfunktionen'">
					<AccountCog/>
				</md-button>	

				<md-button v-if="!loggedIn && enableCommunication && sessionID" class="md-icon-button" :class="{ 'active-Icon': loginDialogueVisible}"  @click="toggleLoginDialogue" :md-ripple="false" @mouseover="buttonName = 'Kommunikation'">
					<img src="@/assets/Communication.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button class="md-icon-button" :class="{ 'active-Icon': tutorialVisible}" @click="toggleTutorialDialogue" :md-ripple="false" @mouseover="buttonName = 'Hilfe'">
					<img src="@/assets/Tutorial.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button v-if="gyrosSupported" class="md-icon-button" :class="{ 'active-Icon': gyrosActive }" :md-ripple="false" @click="toggleGyros">
					<img src="@/assets/gyrosicon.png" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button v-if="enableBugReport" class="md-icon-button" :class="{ 'active-Icon': bugReportVisible }" @click="toggleBugReport" :md-ripple="false" @mouseover="buttonName = 'Fehlermeldung'">
					<img src="@/assets/bugreport icon.png" class="na-navbar-button-img" alt=""/>
				</md-button>	
			</div>
		</div>	

	</div>
</template>

<script>
import {mapGetters} from 'vuex';

import MapOutline from 'vue-material-design-icons/MapOutline.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import FullScreenIcon from 'vue-material-design-icons/Fullscreen.vue'
import FullScreenExitIcon from 'vue-material-design-icons/FullscreenExit.vue'
import ShareIcon from 'vue-material-design-icons/ShareVariant.vue'
import LoginIcon from 'vue-material-design-icons/Login.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue'
import MonitorShareIcon from 'vue-material-design-icons/MonitorShare.vue'
import AccountCog from 'vue-material-design-icons/AccountCog.vue'

export default {
	components: {MapOutline, ChevronDown, ChevronUp, FullScreenIcon, FullScreenExitIcon, ShareIcon, LoginIcon, ChevronRight, AccountGroup, MonitorShareIcon, AccountCog},
	inject: ['toggleMap','toggleGallery','toggleLoginDialogue','toggleSharing','toggleGyros','toggleBugReport','isVideoPanorama','toggleModeratorMenue',"toggleFullScreen","toggleTutorialDialogue"],
	props: ["mapVisible","fullScreen","loginDialogueVisible","gyrosActive","bugReportVisible","situationGalleryVisible","sharingVisible","loggedIn","comVisible","gyrosSupported","localUserIsModerator","tutorialVisible"],
	data: () => ({
    	buttonName: '',
	}),
	computed: {
		...mapGetters(['currentSituation','enableMap',"enableSharing",'enableCommunication','enableBugReport',"localUser","sessionID"]),
	},
	mounted(){
		for(let child of document.getElementsByClassName("na-navbar-buttons")[0].children){
			child.addEventListener("mouseleave", () => {
				this.buttonName = "";
			});
		}
	}
}
</script>


<style scoped>
.Navigation{
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	justify-content: center;
}
.na-gallery{
	position: absolute;
	height: 70px !important;
	top: 0;
	width: 100% !important;
}
.na-navbar{
	position: absolute;
	bottom: 10px !important;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.na-navbar-tooltip{
	z-index: 2;
	margin-bottom: 10px;
	font-size: 25px;
    color: white;
    filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.4)) drop-shadow(0px 0px 10px rgba(0,0,0,0.2));
}
.na-navbar-buttons{
	justify-content: center;
    display: flex;
    flex-direction: row;
}
.na-navbar-buttons .md-button{
	margin: 5px;
}
.md-button {
	margin: 0;
	padding: 0;
}
.md-icon-button {
	border-radius: 3px;
	background-color: transparent;
	filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.4)) drop-shadow(0px 0px 10px rgba(0,0,0,0.2));
	height: 50px;
	width: 60px;
}
.material-design-icon{
	height: 2.3em;
	width: 2.3em;;
}
.material-design-icon > .material-design-icon__svg{
	height: 2.3em;;
	width: 2.3em;;
	fill: white;
}
.md-icon-button .md-ripple {
	padding: 0;
	border-radius: 3px;
}
.md-icon-button:hover::before{
	background-color: #1d1d1d;
	border-radius: 2px;
}
.na-navbar-button-img{
	width: 35px; 
	height: auto;
}
.active-Icon {
	background-color: var(--primaryColor) !important;
}
.notification {
	background-color: transparent;
	animation-name: notification-animation;
	animation-duration: 0.5s;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}
@keyframes notification-animation {
	from {background-color: transparent;}
	to {background-color: var(--primaryColor);}
}
.situationName{
	line-height: 30px;
	padding-top: 10px;
	cursor: pointer; 
	font-size: 2vw; 
	margin: 10px;
	color: white;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .1s;
}

/*MOBILE*/
@media (max-device-width: 900px){
	.situationName{
		font-size: 25px;
	}
}
@media (max-width: 1600px){
	.situationName{
		font-size: 25px;
	}
}
</style>